import axios from "axios";
import Link from "next/link";
import React from "react";
import { GoogleReCaptchaProvider,  useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useForm } from "react-hook-form";
import MySwal from "sweetalert2";

const alertContent = () => {
  MySwal.fire({
    title: "Congratulations!",
    text: "Your message was successfully send and will back to you soon",
    icon: "success",
    timer: 2000,
    timerProgressBar: true,
    showConfirmButton: false,
  });
};

const alertErrorContent = (error) => {
  MySwal.fire({
    title: "Error Occured!",
    text: error,
    icon: "error",
    timerProgressBar: false,
    showConfirmButton: false,
  });
};

// Form initial state
const INITIAL_STATE = {
  name: "",
  email: "",
  contactnumber: "",
  message: "",
  isAu: false,
  captcha: "",
};

const ContactForm = ({ googleReCaptchaProps }) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const [contact, setContact] = React.useState(INITIAL_STATE);
  const [message, setMessage] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);
  const recaptchaRef = React.createRef();
  const [terms, setTerms] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  const privacyLink = isAU ? "/privacy-policy" : "/privacy-policy-nz";

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContact((prevState) => ({ ...prevState, [name]: value }));
  };
  const onSubmit = async (values) => {
    
    try {
      values.isAu = isAU;      

      const token = await executeRecaptcha("contact");
      const payload = { ...contact, captcha: token };
      const url = `/api/contact`;
      const response = await axios.post(url, payload);

      if (response.status === 200) {
        alertContent();
      } else {
        throw new Error(response.data);
      }

      reset();
    } catch (error) {
      alertErrorContent(error?.message || "Something went wrong");
    }
  };

  const onVerifyCaptcha = (token) => {
    setContact((prevState) => ({ ...prevState, ["captcha"]: token }));
  };

  const openTermsModal = () => {
    setOpenModal(true);
  };

  const modalEnable = () => {
    setModalShow(true);
  };

  const windowModal = () => {
    if (modalShow) setModalShow(false);
    else return;
  };

  return (
    <div>
      <div
        className='page-wrapper flex-grow-1'
        style={{ opacity: modalShow ? "25%" : "100%" }}
      >
        <div className='product-detail-section container new-space py-md-3 py-0 py-lg-5'>
          <div className='col-12'>
            <span className='fs-1 fw-black lh-1'>Contact</span>
            <br />
            <hr />
            <span className='fs-2 fw-bold lh-1'>
              {isAU && <span>Call our Customer Service Team 1800 804 541</span>}
              {!isAU && (
                <span>Call our Customer Service Team 0800 838 222</span>
              )}
            </span>
            <br />
            <span className='lh-lg fw-500'>Monday to Friday 8am to 5pm</span>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            {message ? (
              <div className='alert alert-primary my-5'>
                Thank you, your information has been submitted for our records.
              </div>
            ) : (
              <>
                <br />
              </>
            )}

            {hasError ? (
              <div className='alert alert-danger my-5'>
                Please correct the information below.
              </div>
            ) : (
              <>
                <br />
              </>
            )}

            <div className='row form'>
              <div className='col-sm-6'>
                <fieldset>
                  <div className='form-group mb-4'>
                    <label className='required'>Name</label>
                    <input
                      {...register("name", {
                        onChange: (e) => handleChange(e),
                        required: true,
                      })}
                      style={{ boxShadow: "none" }}
                      placeholder='Your Name'
                      className='form-control'
                    />
                    {errors?.name && (
                      <p style={{ color: "red" }}>Name is required.</p>
                    )}
                  </div>

                  <div className='form-group mb-4'>
                    <label className='optional'>Business Email</label>
                    <input
                      {...register("email", {
                        onChange: (e) => handleChange(e),
                        required: "required",
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "Entered value does not match email format",
                        },
                      })}
                      id='email'
                      className='form-control'
                      style={{ boxShadow: "none" }}
                      placeholder='Your Email'
                      type='email'
                    />
                    {errors?.email && (
                      <p style={{ color: "red" }}>Email is required.</p>
                    )}
                  </div>
                </fieldset>
              </div>
              <div className='col-sm-6'>
                <div className='form-group mb-4'>
                  <label className='optional'>Best Contact Number</label>
                  <input
                    {...register("contactnumber", {
                      onChange: (e) => handleChange(e),
                      required: true,
                    })}
                    style={{ boxShadow: "none" }}
                    className='form-control'
                    placeholder='Your Phone'
                    id='contactnumber'
                    name='contactnumber'
                    type='tel'
                    autoComplete='tel'
                  />
                  {errors?.contactnumber && (
                    <p style={{ color: "red" }}>Number is required.</p>
                  )}
                </div>
                <div className='form-group mb-4'>
                  <label className='required'>Message</label>
                  <textarea
                    {...register("message", {
                      onChange: (e) => handleChange(e),
                      required: true,
                    })}
                    style={{ boxShadow: "none", height: "150px" }}
                    className='form-control contact-message'
                    id='message'
                    name='message'
                    placeholder='Your Message'
                    type='text'
                  />
                  {errors?.message && (
                    <p style={{ color: "red" }}>Text Body is required.</p>
                  )}
                </div>
              </div>
              <div className='col-6 d-flex d-md-flex d-sm-none'></div>
              <div className='col-md-6 col-sm-12 d-flex'>
                <p
                  className='card-text text-right ms-auto'
                  style={{ textAlign: "right" }}
                >
                  The information you provide is voluntary however if you do not
                  provide the requested information we may not be able to verify
                  your details and properly attend to your enquiry. Your
                  information will be used by Ryco Group Pty Limited to process
                  your request, be retained for reference for future enquiries
                  and managed in accordance with our&nbsp;
                  <Link href={privacyLink} legacyBehavior>
                    <a>Privacy Policy</a>
                  </Link>
                  . You may request access to your personal information by
                  contacting us privacy@rycogroup.com.
                </p>
              </div>
              <div className='form-group mb-4' style={{ textAlign: "right" }}>
                <input
                  value={terms}
                  onChange={() => setTerms(!terms)}
                  type='checkbox'
                  className='form-check-input shadow-none rounded'
                  id='terms'
                />
                <label
                  className='optional'
                  style={{
                    paddingLeft: "4px",
                    fontSize: "1.2rem",
                    border: "1px solid grat",
                  }}
                  htmlFor='terms'
                >
                  &nbsp;I agree
                  {/* <a
                    onClick={modalEnable}
                    className="text-red rounded p-1"
                    style={{ boxShadow: "none", cursor: "pointer" }}
                  >
                    Terms & Conditions
                  </a> */}
                </label>
              </div>
              <div className='col-12 d-flex'>
                <button
                  disabled={!terms}
                  style={{ boxShadow: "none" }}
                  type='submit'
                  className='btn btn-primary btn-lg ms-auto mb-3 mb-md-0'
                >
                  Send Message
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {modalShow && (
        <div
          style={{
            height: "100vh",
            justifyContent: "center",
            display: "flex",
            placeItems: "center",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: "auto",
          }}
          onClick={windowModal}
        >
          <div className='card' style={{ minWidth: "18rem", width: "700px" }}>
            <div className='card-body'>
              <div className='hstack gap-3'>
                <h5 className='card-title'>Privacy Policy</h5>
                <div
                  className='ms-auto'
                  style={{ cursor: "pointer" }}
                  onClick={() => setModalShow(false)}
                >
                  ❌
                </div>
              </div>
              <p className='card-text'>
                Thank you for your enquiry. The information you provide is
                voluntary however if you do not provide the requested
                information we may not be able to verify your details and
                properly attend to your enquiry. Your information will be used
                by Ryco Group Pty Limited to process your request, be retained
                for reference for future enquiries and managed in accordance
                with our&nbsp;
                <Link href={privacyLink} legacyBehavior>
                  <a>Privacy Policy</a>
                </Link>
                . You may request access to your personal information by
                contacting us privacy@rycogroup.com.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm;
